<template>
<div class="card position-relative overflow-auto">
	<div class="dash-card-header"> 

	</div>
</div>
</template>

<script>
export default {
	data() {
		return {
			data: {
				token: ''
			}
		};
	},
	async mounted() {

		if (this.$route.params.key) {
			this.data.token = this.$route.params.key
			try {
				 await this.$store.dispatch('directLogin', this.data);
				
				
				await this.$router.push({ name: 'dashboard', params: {lang: localStorage.getItem('locale')}});
				
			} catch {
				await this.$router.push({ name: 'home', params: {lang: localStorage.getItem('locale')}});
			}
			
		}
	}
}

</script>